
import Verificationemail from "components/Verificationemail/Verificationemail";
import AddMarket from "views/dashboard/Addmarket";
import Addnetwork from "views/dashboard/Addnetwork";
import Addpairs from "views/dashboard/Addpairs";
import Addtoken from "views/dashboard/Addtoken";
import Dashboard from "views/dashboard/Dashboard.js";
import Market from "views/dashboard/Market";
import Marketdetails from "views/dashboard/Marketdetails";
import PairDetail from "views/dashboard/PairDetail";
import Pairs from "views/dashboard/Pairs";
import Tokendetails from "views/dashboard/Tokendetails";

var routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    layout: "/admin",
  },
  {
    path: "/tokendetails",
    name: "Token details",
    component: Tokendetails,
    layout: "/admin",
  },
  {
    path: "/addtoken",
    name: "Add Token",
    component: Addtoken,
    layout: "/admin",
  },
  {
    path: "/addmarket",
    name: "Add Market",
    component: AddMarket,
    layout: "/admin",
  },
  {
    path: "/market",
    name: "All Market",
    component: Market,
    layout: "/admin",
  },
  {
    path: "/marketdetails",
    name: "Market Detail",
    component: Marketdetails,
    layout: "/admin",
  },
  {
    path: "/pairdetails",
    name: "Pair Detail",
    component: PairDetail,
    layout: "/admin",
  },
  // {
  //   path: "/verificationemail",
  //   name: "Verificationemail",
  //   component: Verificationemail,
  //   layout: "/admin",
  // },
  {
    path: "/addnetwork",
    name: "Add Network",
    component: Addnetwork,
    layout: "/admin",
  },
  {
    path: "/pairs",
    name: "Pairs",
    component: Pairs,
    layout: "/admin",
  },
  {
    path: "/addpairs",
    name: "Add Pairs",
    component: Addpairs,
    layout: "/admin",
  },
];
export default routes;

